<template>
  <div v-if="flag.ready">
    <Print
      v-if="!flag.invalid && user"
      :user="user" />
    <div v-else>
      <p>URLが正しくないか、本ページを表示する権限がありません。</p>
      <p>アカウントタブの利用者リストから遷移してこの表示がされている場合は、<br>お手数ですが事務局までお知らせください。</p>
    </div>
  </div>
</template>

<script>
import Print from '@/views/components/Print.vue';
import cf from '@/mixins/commonFunctions.js';

export default {
  name: 'PrintIndivisualWrapper',
  mixins: [cf],
  components: {
    Print,
  },
  data() {
    return {
      userId: null,
      user: null,
      flag: {
        ready: false,
        invalid: false,
      },
    };
  },
  created() {
    this.showLoading();

    if (this.$route.params?.user_id) {
      // パスパラメータのuser.idを取得
      const uid = cf.convert2Num(this.$route.params.user_id);
      if (!cf.isNumber(uid)) {
        this.flag.invalid = true;
        this.hideLoading();
        return;
      }
      this.userId = uid;
    } else {
      this.flag.invalid = true;
    }

    this.getUser();
  },
  computed: {
  },
  methods: {
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },
    /** ローディング非表示 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    /** ユーザー情報を取得 */
    getUser() {
      this.axios({
        method: 'GET',
        url: '/v1/user/get/detail',
        params: {
          id: this.userId,
        },
      })
        .then((response) => {
          const user = response.data.data;
          if (user.flag === 1 && user.temporary === 1) {
            // 仮登録中で無効でないユーザーのみを対象とする
            this.user = response.data.data;
          } else {
            this.flag.invalid = true;
          }
        })
        .catch((error) => {
          console.log(error.response?.data || error);
          this.flag.invalid = true;
        })
        .finally(() => {
          this.flag.ready = true;
          this.hideLoading();
        });
    },
  },
};
</script>
